import type { ParsedLocation } from '@tanstack/react-router'
import { authClient } from './auth-client'
import { invalidateSessionQuery } from './session'

// Games pass a one-time token in the URL fragment, which browsers never send to servers.
// Remove it from the address bar and history before using it.
export function takeUrlToken(location: ParsedLocation): string | null {
  const token = new URLSearchParams(location.hash.replace(/^#/, '')).get('token')
  if (token) {
    window.history.replaceState(
      window.history.state,
      '',
      `${location.pathname}${location.searchStr}`,
    )
  }
  return token
}

// Sign this browser in to the login the token was issued for, replacing any current login.
export async function signInWithToken(token: string): Promise<boolean> {
  try {
    const { error } = await authClient.oneTimeToken.verify({ token })
    invalidateSessionQuery()
    return !error
  } catch {
    return false
  }
}
